import { firebase } from "astrid-firebase";

const call = firebase.functions().httpsCallable("loginToken");

export default async function loginToken() {
	const { data } = await call();

	return data;
}
